import * as React from 'react';

import { X } from 'lucide-react';
import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';
import { Drawer as VaulDrawer } from 'vaul';

const drawerVariants = tv({});

export type DrawerProps = VariantProps<typeof drawerVariants> & {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
};

export const Drawer: React.FC<DrawerProps> = ({ children, ...props }) => {
  return (
    <VaulDrawer.Root
      direction="right"
      onOpenChange={props.onOpenChange}
      open={props.open}
    >
      <VaulDrawer.Portal>
        <VaulDrawer.Overlay className="fixed inset-0 z-50 bg-black/40" />
        <VaulDrawer.Content className="fixed bottom-0 right-0 top-0 z-[51] flex w-[480px] outline-none">
          <div className="flex h-full w-full grow flex-col bg-white">
            <div className="relative">
              <VaulDrawer.Title className="border-b border-gray-200 p-6 text-lg font-medium text-zinc-900">
                Appointment information
              </VaulDrawer.Title>
              <VaulDrawer.Close className="absolute right-6 top-1/2 -translate-y-1/2">
                <X className="size-5 text-gray-400" />
              </VaulDrawer.Close>
            </div>
            <div className="p-6">{children}</div>
          </div>
        </VaulDrawer.Content>
      </VaulDrawer.Portal>
    </VaulDrawer.Root>
  );
};

Drawer.displayName = 'Drawer';
